import { ContextMenu, ContextMenuDeleteWithModelUsageItem, ContextMenuItem, Id, useHasPermission } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { PermissionName } from "../../../shared/types/permission";
import { costCategoryService } from "../shared/api/costCategoryService";

interface Props {
	costCategoryId: Id;
	onEdit: () => void;
	onDelete: () => void;
}

export const CostCategoryListContextMenu: FC<Props> = ({ costCategoryId, onEdit, onDelete }) => {
	const { t } = useTranslation();

	const showUsageAction = useCallback(
		() => costCategoryService.usages(costCategoryId).then((r) => r.data.data),
		[costCategoryId],
	);

	const canUpdate = useHasPermission<PermissionName>(["costCategory.update"]);
	const canDelete = useHasPermission<PermissionName>(["costCategory.delete"]);

	return (
		<ContextMenu displayShortcutsAs="icon" size="small">
			{canUpdate && (
				<ContextMenuItem
					action={onEdit}
					title={t("Edit cost category")}
					label={t("Edit cost category")}
					icon="edit"
					shortcut="primary"
				/>
			)}
			{canDelete && (
				<ContextMenuDeleteWithModelUsageItem
					label={t("Delete cost category")}
					title={t("Delete cost category")}
					showUsageAction={showUsageAction}
					modelName={t("Cost category")}
					confirmationBody={t("Are you sure you want to delete this cost category?")}
					deleteAction={onDelete}
				/>
			)}
		</ContextMenu>
	);
};
